<template>
    <div v-if="review">
        <div class="profile-review-single-view-top">
            <div class="profile-review-author">{{ review.author.username }}</div>
            <div class="profile-review-date">{{ timeToLocal(review.created_at) }}</div>
            <div class="profile-review-rating d-flex">
                <icon-component width="1.1em" v-for="i in review.rating" class="review-star selected" :icon="fa_star()" :key="`star-${i}`"></icon-component>
                <icon-component width="1.1em" v-for="i in (5 - review.rating)" class="review-star" :icon="fa_star()" :key="`star-${6-i}`"></icon-component>
            </div>
            <a v-if="isAdmin && showDelete" class="profile-review-delete" title="Delete comment" @click="deleteReview">
                <icon-component class="cursor-pointer" :icon="fa_trash()"></icon-component>
            </a>
        </div>

        <div class="profile-review-singe-view-title">
            {{ review.title }}
        </div>

        <div class="profile-review-singe-view-text mt-1">{{ review.text }}</div>

        <template v-if="canReply">
            <div class="profile-review-single-view-bottom mt-3" v-if="!review.reply && !showReplyForm">
                <div class="reply-to-review-button ml-sm-2" @click="showReviewReplyForm">
                    <icon-component :icon="fa_reply_all()"></icon-component>
                    <span e2e-id="show-reply-form-button"
                    >{{ translate.account.reviews.reply }}</span>
                </div>
            </div>

            <div class="profile-review-reply-form row" v-if="showReplyForm && !review.reply">
                <textarea cols="30" rows="5" class="profile-reviews-reply-text mt-2"
                          v-model.trim="replyText"
                          :placeholder="translate.account.reviews.replyTextPlaceholder">
                </textarea>

                <p class="mb-1 mb-sm-2 px-0" e2e-id="profile-review-reply-characters-left">
                    {{ translate.home.charactersLeft1 }} {{ textCharsLeft }} {{ translate.home.charactersLeft2 }}
                </p>

                <button-with-loading-component e2e-id="button-create-review-reply"
                                               class="btn btn-primary col-11 col-sm-4 offset-sm-7 mt-2 mt-sm-0"
                                               @click.native="createReviewReply"
                                               :text="translate.account.reviews.reply"
                                               :loading="loading"
                                               :disabled="!formFilled"
                                               type="button">
                </button-with-loading-component>
            </div>
        </template>

        <div class="profile-review-single-view-response" v-if="review.reply">
            <div class="review-response-from">
                {{ translate.account.reviews.replyFrom }}: {{ userProp.username }}
            </div>

            <div class="review-response-text">{{ review.reply }}</div>
        </div>

    </div>
</template>

<script>

import {isUserAdmin} from "@/core/utils/helpers/users/roles/rolesHelper";
import {fa_reply_all, fa_star, fa_trash} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

const data = () => {
    return {
        moment: moment,
        showReplyForm: false,
        replyText: '',
        loading: false,
        textMaxLength: 500,
        reviewWithReply: null,
        showDelete: true,
    }
}

function timeToLocal(timestamp) {
    this.moment.locale(this.locale);

    const serverDate = this.moment.tz(timestamp, 'Europe/Berlin');
    const userTimeZone = this.moment.tz.guess(true);

    let format = 'MMMM DD';

    if (userTimeZone) {
        serverDate.tz(userTimeZone);
    }

    const reviewYear = serverDate.year();
    const currentYear = this.moment().year();

    if (reviewYear < currentYear) {
        format += ' YYYY';
    }

    return serverDate.format(format);
}

function showReviewReplyForm() {
    this.showReplyForm = true;
}

async function createReviewReply() {
    this.loading = true;

    const [err, response] = await to(
        api.user.reviews.reply(this.review.id, {reply: this.replyText})
    )

    this.loading = false;

    if (err || !_.get(response, 'data.success', false)) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.reviewWithReply = _.get(response, 'data.review', null);
}

async function deleteReview() {
    let accept = confirm('Are you sure you wish to delete?');

    if (!accept) {
        return;
    }
    this.showDelete = false;
    const [err, response] = await to(
        api.user.reviews.delete(this.review.id)
    );

    if (err || !_.get(response, 'data.success')) {
        this.showDelete = true;
        return toastr.error(this.translate.home.errorCommon);
    }

    this.$emit("deleted");
}

export default {
    components: {IconComponent},
    data,
    computed: {
        ...mapState(['currentUser', 'translate', 'managerAsEscortData', 'locale']),
        formFilled() {
            return this.replyText.length > 2;
        },
        textCharsLeft() {
            return this.textMaxLength - _.get(this, 'replyText.length', 0);
        },
        review() {
            return this.reviewWithReply || this.reviewProp;
        },
        canReply() {
            if (!this.currentUser) {
                return false;
            }

            const independentEscortOrPunter = (!this.userProp.manager_id && this.userProp.id === this.currentUser.id);
            const escortsManager = (this.userProp.manager_id && this.userProp.manager_id === this.currentUser.id);
            const managerAsEscort =
                _.get(this, 'managerAsEscortData.id', -1) === _.get(this, 'userProp.manager_id', 0);

            return independentEscortOrPunter || escortsManager || managerAsEscort;

        },
        isAdmin() {
            return isUserAdmin(this.currentUser);
        }
    },
    watch: {
        textCharsLeft(value) {
            if (value <= -1) {
                this.replyText = this.replyText.substr(0, this.textMaxLength);
            }
        },
    },
    props: ['reviewProp', 'userProp'],
    methods: {
        fa_reply_all,
        fa_trash,
        fa_star,
        timeToLocal,
        createReviewReply,
        showReviewReplyForm,
        deleteReview,
    }
}
</script>
